const initialState = {
    responseBackendScaleList: {},
    responseBackendScaleDetail: null,
    responseCreate: null,
    responseUpdate: null,
    loading: false,
    error: null,
};

export default function backendScaleReducer(state = initialState, action) {
    switch (action.type) {

        // LISTADO

        case 'BACKEND_SCALE_LIST_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'BACKEND_SCALE_LIST_RESPONSE':
            return {
                ...state,
                loading: false,
                responseBackendScaleList: action.value,
            };

        case 'BACKEND_SCALE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        // DETALLE

        case 'BACKEND_SCALE_DETAIL_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'BACKEND_SCALE_DETAIL_RESPONSE':
            return {
                ...state,
                loading: false,
                responseBackendScaleDetail: action.value,
            };

        // CREATE

        case 'BACKEND_SCALE_CREATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseCreate: null,
            };

        case 'BACKEND_SCALE_CREATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseCreate: action.value,
            };

        case 'BACKEND_SCALE_CREATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        // UPDATE

        case 'BACKEND_SCALE_UPDATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseUpdate: null,
            };

        case 'BACKEND_SCALE_UPDATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseUpdate: action.value,
            };

        case 'BACKEND_SCALE_UPDATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case 'BACKEND_SCALE_CLEAR_STATE':
            return {
                ...state,
                error: null,
                responseCreate: null,
                responseUpdate: null,
            };

        default:
            return state;
    }
}
